<template lang="pug">
  div
    e-modal(v-if="showModal"
    @close="showModal = false"
    @confirm="save()"
    title="Выбор почтового отделения"
    )
      slot
        e-table-checked-list(
        selectType="radio"
        @checkedChange="update"
        :endpoint="endpointList"
        :earlyCheckedItems="getEarlyChecked()"
        :showPaginate="true"
        placeholder="Введите индекс"
        )

    div
      div.table-choose-panel
        div.toolbar-table
          div.select Почтовое отделение *
          div.toolbar.toolbar--modal
            div.line
              div.actions-panel
                e-button-edit(@click="showModal=!showModal")


        div.table
          table
            thead
              th Отделение
              th Индекс
              th Адрес
              th Почтамт
              th
            tbody
              tr(v-if="fields.post_office")
                td {{fields.post_office.adr_pochtamt_list}}
                td {{fields.post_office.postindex}}
                td {{fields.post_office.address}}
                td {{fields.post_office.adr_pochtamt}}
                td
                  e-button-delete(
                  @click="remove()"
                  )
              tr(v-else)
                td(colspan=100) Почтовое отделение не указано
</template>

<script>
  import {core} from "../../../api/api-endpoints"

  export default {
    name: "post-office",
    props: {
      fields: null
    },
    data: () => ({
      showModal: false,
      checkedOfficeId: null,
      checkedOffice: null
    }),
    methods: {
      getEarlyChecked () {
        return {
          default: +this.fields.post_office_id
        }
      },
      save () {
        this.fields.post_office_id = +this.checkedOfficeId
        this.fields.post_office = Object.assign({}, this.checkedOffice)
        this.showModal = false
      },
      remove () {
        this.$e.confirmBox('Удалить почтовое отделение', ' ').then(() => {
          this.fields.post_office_id = null
          this.$set(this.fields, 'post_office', null)
        })
      },
      update ($event) {
        let {checked, checkedModels} = $event
        this.checkedOfficeId = +checked.default
        const postOffice = checkedModels.default[checked.default]
        if (postOffice) {
          this.checkedOffice = Object.assign({}, {
            id: postOffice.id,
            address: postOffice.address,
            postindex: postOffice.post_code,
            adr_pochtamt: postOffice.post_office_name,
            adr_pochtamt_list: postOffice.name
          })
        }
      },
      endpointList (ctx) {
        let route = {
          query: {
            'per-page': 50
          }
        }

        if (ctx.q) {
          route.query.q = ctx.q
        }

        if (ctx.paginateObj) {
          route.query = Object.assign(route.query, ctx.paginateObj)
        }

        return {
          url: core.postOffices(route),
          fields: null
        }
      }
    }
  }
</script>
